<template>
    <div :class="prefixCls" 
        @click="handleClick"
        @mouseenter="handleMouseEnter" 
        @mouseleave="handleMouseLeave">
        <div :class="`${prefixCls}-rel`"
            ref="tipElement">
            <slot></slot>
        </div>
        <transition name="fade">
            <div :class="`${prefixCls}-popper ${prefixCls}-popper-${theme} ${prefixCls}-popper-${placement}`"
                :style="styles"
                :placement="placement"
                v-if="visible">
                <slot name="content"></slot>
            </div>
        </transition>
    </div>
</template>
<script>
    import { oneOf } from '../../../utils/assist'

    const prefixCls = 'yy-tip'
    export default {
        props: {
            theme: {
                validator: function (value) {
                    return oneOf(value, ['dark', 'light'])
                },
                default: 'dark'
            },
            placement: {
                validator (value) {
                    return oneOf(value, ['top', 'bottom']);
                },
                default: 'bottom'
            },
            trigger: {
                validator (value) {
                    return oneOf(value, ['hover', 'click']);
                },
                default: 'hover'
            }
        },
        data() {
            return {
                prefixCls: prefixCls,
                visible: false,
                tipElementHeight: 0,
            }
        },
        computed: {
            styles() {
                return [
                    {
                        [`${this.placement === 'top' ? 'bottom' : 'top'}`]: this.tipElementHeight + 'px'
                    }
                ]
            }
        },
        methods: {
            handleClick() {
                if(this.trigger !== 'click') return
                this.visible = !this.visible
            },
            handleMouseEnter() { // 鼠标经过
                if(this.trigger !== 'hover') return
                this.handleShowPopper()
            },
            handleMouseLeave() { // 鼠标离开
                if(this.trigger !== 'hover') return
                this.handleClosePopper()
            },
            handleShowPopper() {
                if (this.timeout) clearTimeout(this.timeout)
                this.timeout = setTimeout(() => {
                    this.visible = true
                }, 200)
            },
            handleClosePopper() {
                if (this.timeout) clearTimeout(this.timeout)
                this.timeout = setTimeout(() => {
                    this.visible = false
                }, 200)
            }
        },
        mounted() {
            this.tipElementHeight = this.$refs.tipElement.offsetHeight + 2
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/base/tip/tips.vue